class ShopifyOEMFormsModal extends window.ShopifyFormsModalBase {
  constructor() {
    super();
    this.form = this.querySelector('[data-oem-forms-form]');
    this.contactFields = this.querySelector('[data-contact-fields]');
    this.companyInfoFields = this.querySelector('[data-company-info-fields]');
    this.additionalInfoFields = this.querySelector('[data-additional-info-fields]');
    this.salesModelOptions = this.querySelectorAll('[data-oem-sales-model]');
    this.resaleChannelsPanel = this.querySelector('[data-resale-channels-panel]');
    this.resaleChannelOptions = this.querySelectorAll('[data-oem-resale-channel]');
    this.resaleChannelOtherCheckbox = this.querySelector('[data-oem-resale-channel-other]');
    this.resaleChannelOtherField = this.querySelector('[data-resale-channel-other-field]');
    this.resaleChannelOtherInput = this.querySelector('input[name="resaleChannelOtherText"]');
    this.sellsOnlineFields = this.querySelectorAll('input[name="sellsOnline"]');
    this.webstoreUrlField = this.querySelector('[data-webstore-url-field]');
    this.webstoreUrlInput = this.querySelector('input[name="webstoreUrl"]');
    this.stringFields = [
      'firstName', 'lastName', 'jobTitle', 'businessEmail', 'phone',
      'legalBusinessName', 'dbaNames', 'companyWebsite',
      'addressLine1', 'addressLine2', 'city', 'stateProvince', 'postalCode', 'country',
      'mainIndustry',
      'salesTerritory', 'webstoreUrl', 'customerBase', 'oemIntegrationPlan', 'salesRepOrAdditionalInfo',
    ];
    this.booleanFields = ['sellsOnline'];
  }

  connectedCallback() {
    super.connectedCallback();
    this.boundHandleSellsOnlineChange = this.toggleWebstoreUrlField.bind(this);
    this.boundHandleSalesModelChange = this.handleSalesModelChange.bind(this);
    this.boundHandleResaleChannelOtherChange = this.handleResaleChannelOtherChange.bind(this);

    this.sellsOnlineFields.forEach((input) => {
      input.addEventListener('change', this.boundHandleSellsOnlineChange);
    });
    this.toggleWebstoreUrlField();
    this.toggleResaleChannelsPanel();

    this.salesModelOptions.forEach((input) => {
      input.addEventListener('change', this.boundHandleSalesModelChange);
    });

    if (this.resaleChannelOtherCheckbox) {
      this.resaleChannelOtherCheckbox.addEventListener('change', this.boundHandleResaleChannelOtherChange);
    }
  }

  disconnectedCallback() {
    this.sellsOnlineFields.forEach((input) => {
      if (this.boundHandleSellsOnlineChange) {
        input.removeEventListener('change', this.boundHandleSellsOnlineChange);
      }
    });
    this.salesModelOptions.forEach((input) => {
      if (this.boundHandleSalesModelChange) {
        input.removeEventListener('change', this.boundHandleSalesModelChange);
      }
    });
    if (this.resaleChannelOtherCheckbox && this.boundHandleResaleChannelOtherChange) {
      this.resaleChannelOtherCheckbox.removeEventListener('change', this.boundHandleResaleChannelOtherChange);
    }
    super.disconnectedCallback();
  }

  toggleWebstoreUrlField() {
    const show = this.getBooleanFieldValue('sellsOnline') === true;
    if (this.webstoreUrlField) {
      this.webstoreUrlField.classList.toggle('hidden', !show);
      if (this.webstoreUrlInput) {
        this.webstoreUrlInput.disabled = !show;
        if (!show) this.webstoreUrlInput.value = '';
      }
    }
  }

  handleSalesModelChange() {
    this.toggleResaleChannelsPanel();
  }

  toggleResaleChannelsPanel() {
    const showValues = new Set(['Direct to end-users', 'Both end-user and dealer sales', 'OEM Part']);
    const shouldShow = Array.from(this.salesModelOptions || []).some(
      (input) => input.checked && showValues.has(input.value)
    );

    if (this.resaleChannelsPanel) {
      this.resaleChannelsPanel.classList.toggle('hidden', !shouldShow);
      this.resaleChannelsPanel.querySelectorAll('input').forEach((input) => {
        input.disabled = !shouldShow;
      });
      if (!shouldShow) {
        this.resaleChannelsPanel.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
          cb.checked = false;
        });
        if (this.resaleChannelOtherInput) this.resaleChannelOtherInput.value = '';
      }
    }

    this.toggleResaleChannelOtherField();
  }

  handleResaleChannelOtherChange() {
    this.toggleResaleChannelOtherField();
  }

  toggleResaleChannelOtherField() {
    const isChecked = !!(this.resaleChannelOtherCheckbox && this.resaleChannelOtherCheckbox.checked);

    if (this.resaleChannelOtherField) {
      this.resaleChannelOtherField.classList.toggle('hidden', !isChecked);
      if (this.resaleChannelOtherInput) {
        this.resaleChannelOtherInput.disabled = !isChecked;
        if (!isChecked) this.resaleChannelOtherInput.value = '';
      }
    }
  }

  resetTransientState() {
    super.resetTransientState();
    this.toggleWebstoreUrlField();
    this.toggleResaleChannelsPanel();
  }

  buildPayload() {
    const payload = super.buildPayload();

    const salesModelValues = Array.from(this.salesModelOptions || [])
      .filter((input) => input.checked)
      .map((input) => input.value);
    if (salesModelValues.length) payload.businessModel = salesModelValues.join('; ');

    const channels = Array.from(this.resaleChannelOptions || [])
      .filter((input) => input.checked)
      .map((input) => input.value);
    if (this.resaleChannelOtherCheckbox && this.resaleChannelOtherCheckbox.checked) {
      const otherText = this.resaleChannelOtherInput ? this.resaleChannelOtherInput.value.trim() : '';
      channels.push(otherText ? `Other: ${otherText}` : 'Other');
    }
    if (channels.length) payload.resaleChannels = channels.join(', ');

    return payload;
  }
}

if (!customElements.get('shopify-oem-forms-modal')) {
  customElements.define('shopify-oem-forms-modal', ShopifyOEMFormsModal);
}
